<template>
  <div id="map"></div>
</template>

<script>
import MapServices from "@/services/mapbox.service";

export default {
  name: "MapView",
  mounted() {
    MapServices.initMap();
  }
};
</script>

<style scoped>
#map {
  width: 100%;
  height: 100%;
}
</style>